export const PROMOTIONS_SET_PROMOS = 'PROMOTIONS_SET_PROMOS';
export const SHOW_PROMOTION = 'SHOW_PROMOTION';